// NPM Imports
import React, { useState } from "react";
import Modal from "react-responsive-modal";
import { NumberInput, Toastr, Button } from "@revvsales/components";

// Internal Imports
import { BILLING } from "../../../../constants";
import { GlobalUtils } from "../../../../utils";
import { sendFeatureRequest } from "../../../../actions/CommonActions/commonService";

// Destructuring
const { CURRENT_PLAN_CHANGE_CONTEXT_POPUP } = BILLING;
const { readDataFromLocalStorage } = GlobalUtils;

export default function PlanChangeRequest(props) {
  // * LOCAL STATE DECLARATION SYNTAX

  const INITIAL_STATE = {
    phoneNumber: "",
  };
  const [state, setState] = useState(INITIAL_STATE);

  function _onPhoneNumberChange(value) {
    setState(Object.assign({}, state, { phoneNumber: value }));
  }

  function _onSubmit() {
    const { currentPlan } = props;
    const body = `A user just requested a callback to change plan from billing page Phone: ${
      state.phoneNumber
    }.
    The user's current plan is ${currentPlan}`;
    const CURRENT_USER = readDataFromLocalStorage("revvsalesUser");
    const {
      first_name: firstName,
      last_name: lastName,
      user_email: userEmail,
      organisation,
    } = CURRENT_USER;
    const data = {
      email: userEmail,
      orgname: organisation,
      subject: `Change plan call back request - Current plan: ${currentPlan} `,
      body,
      username: `${firstName} ${lastName}`,
    };
    sendFeatureRequest(data)
      .then(() => {
        props.onClose();
        Toastr.showToastr({
          type: "success",
          message: "Successfully requested call back",
          timeout: 3000,
        });
      })
      .catch(err => {
        console.error("UpgradePopUp => _onSubmit", err);
      });
  }
  const { welcomeMsg, upsaleMsg } = CURRENT_PLAN_CHANGE_CONTEXT_POPUP;

  return (
    <Modal
      open
      onClose={props.onClose}
      center
      closeOnOverlayClick={false}
      className="planchangerequest-modal-box">
      <div className="planchangerequest-container">
        <section className="planchangerequest-info-section">
          <div className="planchangerequest-welcome-msg">{welcomeMsg}</div>
          <div className="planchangerequest-upsale-msg">{upsaleMsg}</div>
        </section>

        <section className="planchangerequest-callback-section">
          <div className="planchangerequest-callback-txt">
            Please enter your phone number and we will get in touch with you
            soon
          </div>
          <div className="planchangerequest-callback-actions-wrapper">
            <NumberInput
              placeholder="Enter your phone number"
              onChange={value => _onPhoneNumberChange(value)}
              value={state.phoneNumber}
              autoFocus
              data-test="planchangerequest-number-input"
            />
            <div className="planchangerequest-callback-actions">
              <Button
                className="btn btn-primary planchangerequest-submit-btn"
                onClick={() => _onSubmit()}
                disabled={state.phoneNumber.length === 0}
                data-test="planchangerequest-submit-btn">
                Submit
              </Button>
            </div>
          </div>
        </section>
      </div>
    </Modal>
  );
}



// WEBPACK FOOTER //
// ./src/components/SettingsWrapper/BillingSettings/PlanChangeRequest/PlanChangeRequest.js